<template>
  <div class="orderWayBillDetail">
    <van-form label-width="100px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <van-field v-model="form.CreateTime" :label="$t.orderWayBill.createTime" readonly />
      <van-field
        v-model="form.SOPNumber"
        :label="$t.orderWayBill.sopNumber"
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button size="small" type="info" @click="gotoSop">{{
            $t.meta.detail
          }}</van-button>
        </template>
      </van-field>
      <van-field
        v-model="form.SalesUserName"
        :label="$t.orderWayBill.salesUsername"
        readonly
      />
      <van-field
        v-model="form.CustomerNumber"
        :label="$t.orderWayBill.customerNumber"
        readonly
      />
      <van-field
        v-model="form.CompanyNameSn"
        :label="$t.orderWayBill.companyNameSn"
        readonly
      />
      <van-field
        v-model="form.BusinessTypeStr"
        :label="$t.orderWayBill.businessType"
        readonly
      />
      <van-field
        v-model="form.DeliveryCountryCity"
        :label="$t.orderWayBill.deliveryCity"
        readonly
      />
      <van-field
        v-model="form.DestinationCountryCity"
        :label="$t.orderWayBill.destinationCity"
        readonly
      />
      <van-field
        v-model="form.NumberPackages"
        :label="$t.orderWayBill.pNumber"
        readonly
      />
      <van-field v-model="form.Volume" :label="$t.orderWayBill.volume" readonly />
      <van-field v-model="form.Weight" :label="$t.orderWayBill.weight" readonly />
      <van-field v-model="form.GoodsName" :label="$t.orderWayBill.goodsName" readonly />
      <van-field
        v-model="form.CargoStateStr"
        :label="$t.orderWayBill.orderState"
        readonly
      />
    </van-form>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoPrint">{{ $t.meta.print }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "orderWayBillDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("orderWayBillDetail"));
    this.form = data;
  },
  methods: {
    gotoSop() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "commissionCreate",
        name: "commissionCreate",
        query: [
          {
            name: "OrderId",
            value: this.form.OrderId,
          },
          {
            name: "SOPId",
            value: this.form.SOPId,
          },
          {
            name: "isView",
            value: true,
          },
        ],
      });
    },
    gotoPrint() {
      var param = {
        OrderId: this.form.OrderId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createEntrustOrderFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.orderWayBillDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
